export const REPLENISH_PRODUCTS = 'REPLENISH_PRODUCTS';
export const REPLENISH_PRODUCTS_OFFSET = 'REPLENISH_PRODUCTS_OFFSET';
export const REPLENISH_PRODUCTS_COUNT = 'REPLENISH_PRODUCTS_COUNT';
export const REPLENISH_PRODUCTS_SEARCH = 'REPLENISH_PRODUCTS_SEARCH';
export const REPLENISH_BUY_PRODUCT = 'REPLENISH_BUY_PRODUCT';
export const CLEAR_REPLENISH_BUY_PRODUCT = 'CLEAR_REPLENISH_BUY_PRODUCT';
export const REPLENISH_PRODUCTS_LOADING = 'REPLENISH_PRODUCTS_LOADING';
export const REPLENISH_PRODUCTS_SUPPLIER_ID = 'REPLENISH_PRODUCTS_SUPPLIER_ID';
export const REPLENISH_PRODUCTS_BRANDS = 'REPLENISH_PRODUCTS_BRANDS';
export const REPLENISH_PRODUCTS_LOADING_PRODUCTS = 'REPLENISH_PRODUCTS_LOADING_PRODUCTS';
